import { createSelector } from '@reduxjs/toolkit';
import { selectPortfoliosState } from '../../store/selectors';

export const selectAfsls = createSelector(selectPortfoliosState, (portfolios) => portfolios.afsls);

export const selectAfslId = createSelector(selectPortfoliosState, (portfolios) => portfolios.afslId);

export const selectTemplates = createSelector(selectPortfoliosState, (portfolios) => portfolios.templates);
